export const mapNotificationName = (notification: string) => {
  const cleanedString = notification.replace(/[{}']/g, "");
  const list = cleanedString.split(", ").map((value) => value.trim());
  const map: any = {
    "0": "Correo electrónico",
    "1": "Mensaje SMS",
    "2": "Aplicación web",
    "3": "WhatsApp",
  };
  const resultString = list.map((item) => map[item]).join(", ");

  return resultString;
};

export const mapSubName = (sub: string) => {
  const map: any = {
    "{'1'}": "Alerta de proximidad de camiones",
    "{'2'}": "Inició de recolección",
  };

  return map[sub];
};
